import React, { useState, useEffect } from 'react';
import FetchUserData from '../components/fetchUserData';
import SentimentScoreHistory from './sentiment-score-history/sentiment-score-history';
import OverallSentiment from './overall-sentiment/overall-sentiment';
import { CircularProgress, Typography } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CachedIcon from '@mui/icons-material/Cached';
import './styles.css';

const CustomerSentiment = () => {
    const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const [ticketId] = useState(params.id || '');  
    const [showError, setShowError] = useState(false);
    const [historyData, setHistoryData] = useState(null);
    const [overallScoreData, setOverallScoreData] = useState(null);
    const [historyError, setHistoryError] = useState(null);
    const [historyErrorMsg, setHistoryErrorrMsg] = useState(null);
    const [overallScoreError, setOverallScoreError] = useState(null);
    const [overallScoreErrorMsg, setOverallScoreErrorMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    // Fetch user data from Manage Hosted Pod API
    const fetchUserDataResult = FetchUserData({ setLoading, setShowError });
    const { userData, createdCwApi } = fetchUserDataResult;

    // Fetch sentiment data
    useEffect(() => {
        if (userData) {
            console.log("Inside sentiment history - userData: ", userData);
            fetch(apiUrl + '/api/get_note_sentiment' , {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ ticketId: ticketId, userData: userData }, null, 2),
            })
            .then(response => response.json())
            .then(data => {
                console.log('Inside sentiment history - data:', data);
                if (data.response === "No Notes found with Sentiment Scores.") {
                    setHistoryError(true);
                    setOverallScoreErrorMsg(data.response);
                } else {
                    setHistoryData(data);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                setHistoryError(true);
            });
        }
    }, [apiUrl, ticketId, userData]);

    // Fetch sentiment score
    useEffect(() => {
        if (userData) {
            console.log("Inside sentiment score - userData: ", userData);
            fetch(apiUrl + '/api/get_overall_sentiment' , {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ ticketId: ticketId, userData: userData }, null, 2),
            })
            .then(response => response.json())
            .then(data => {
                console.log('Inside sentiment score - data:', data);
                if (isNaN(data)) {
                    setOverallScoreError(true);
                    setOverallScoreErrorMsg(data);
                } else {
                    setOverallScoreError(false);
                    setOverallScoreErrorMsg('');
                    data = parseInt(data, 10)
                    setOverallScoreData(data);
                }    
            })
            .catch((error) => {
                console.error('Error:', error);
                setOverallScoreErrorMsg(error);
                setOverallScoreError(true);
            });
        }
    }, [apiUrl, ticketId, userData]);

    const handleRescore = () => {
        setIsLoading(true);
        console.log("Regenerating Overall Sentiment.");
        fetch(apiUrl + '/api/get_overall_sentiment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, refreshScore: true }, null, 2),
        })
        .then(response => response.json())
        .then(data => {
            console.log('Rescore - New sentiment score:', data);
            if (isNaN(data)) {
                setIsLoading(false);
                setOverallScoreError(true);
                setOverallScoreErrorMsg(data.response);
            } else {
                setOverallScoreError(false);
                setOverallScoreErrorMsg('');
                data = parseInt(data, 10)
                setOverallScoreData(data);
                setIsLoading(false);
                createdCwApi.post({ "request": "refreshScreen", "args": {} });
            }    
        })
        .catch((error) => {
            console.error('Error during rescore:', error);
            setOverallScoreError(true);
        });
    };

    const regenContactHistory = () => {
        setIsLoading(true);
        console.log("Regenerating Contact History");
        fetch(apiUrl + '/api/get_note_sentiment' , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, refreshHistory: true }, null, 2),
        })
        .then(response => response.json())
        .then(data => {
            console.log("Inside sentiment history regenContactHistory - data: ", data);
            if (data.response === "No Notes found with Sentiment Scores.") {
                setIsLoading(false);
                setHistoryError(true);
                setHistoryErrorrMsg(data.response);
            } else {
                setHistoryData(data);
                setIsLoading(false);
                createdCwApi.post({ "request": "refreshScreen", "args": {} });
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            setIsLoading(false);
            setHistoryError(true);
            setHistoryErrorrMsg(error);
        });
        
    }

    return (
        <>
            {loading ? (
                <>
                    <Typography variant="h5" align="center">Loading...</Typography>
                    <div style={{ textAlign: 'center' }}>
                        <CircularProgress />
                    </div>
                </>
            ) : showError ? (
                <Typography variant="h3" align="center">Error getting User Data.  Reload the Pod.</Typography>      
            ) : (
                <section className="outter-container">
                    <div className="inner-container">
                        <div className="header">
                            <div class="header-middle-container">
                                {overallScoreError ? (
                                <>
                                    <div style={{ fontSize: '1.6em' }}>{overallScoreErrorMsg}</div>
                                    <div style={{ textAlign: 'center' }}>
                                        <Tooltip title="Generate Sentiment & Update Ticket">
                                            <LoadingButton
                                                size="small"
                                                loading={isLoading}
                                                loadingPosition="end"
                                                variant="outlined"
                                                onClick={handleRescore}
                                                endIcon={<CachedIcon />}>Generate Sentiment
                                            </LoadingButton>
                                        </Tooltip>
                                    </div>
                                </>
                                ) : !overallScoreData ? (
                                    <div style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <OverallSentiment overallScore={overallScoreData} onRescore={handleRescore}/>
                                )}
                            </div>
                        </div>
                        {historyError ? (
                        <>
                            <div style={{fontSize: '1.7em', marginLeft: '20px'}}>{historyErrorMsg}</div>
                            <Tooltip title="Generate Contact Note Sentiment History">
                            <LoadingButton
                                style={{ marginLeft: '20px', width: '200px' }}
                                size="small" 
                                onClick={regenContactHistory} 
                                variant="outlined" 
                                endIcon={<CachedIcon />} 
                                loading={isLoading} 
                                loadingPosition="end">Generate History
                            </LoadingButton>
                        </Tooltip> 
                        </>
                        ) : !historyData ? (
                            <div style={{ textAlign: 'center' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <SentimentScoreHistory historyData={historyData} regenContactHistory={regenContactHistory} />
                        )}
                    </div>
                </section>
            )}
        </>
    );
};

export default CustomerSentiment;